import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "results"];
  static values = { url: String };

  fetch() {
    const query = this.inputTarget.value;

    if (query.length < 3) {
      this.resultsTarget.classList.add("hidden");
      this.resultsTarget.innerHTML = "";
      return;
    }

    fetch(`${this.urlValue}?query=${encodeURIComponent(query)}`)
      .then(response => response.text())
      .then(html => this.updateResults(html))
  }

  updateResults(html) {
    this.resultsTarget.innerHTML = html
    this.resultsTarget.classList.remove("hidden");
  }

  select(event) {
    this.inputTarget.value = event.target.dataset.value;
    this.resultsTarget.classList.add("hidden");
  }
}
